import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Block3Columns from "../../components/Block3Columns";
import ConectUs from "../../components/ConectUs";
import OfferPosgrados from "../../components/view/OfferPosgrados";
import { motion } from "framer-motion";
import PosgradoPagos from "../../components/PosgradoPagos";
import Modal from "../../components/Modal";
import ImageGallery from "../../components/ImageGallery";
import DescuentosPosgrados from "./DescuentosPosgrados";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/51ae7ef1-57ff-440d-a341-a7a7bd441116" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Posgrados() {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2,
      },
    },
  };

  const DataDisplay = ({ data }) => {
    const hasGallery = Array.isArray(data?.galeria)
      ? data.galeria.length > 0
      : Boolean(data?.galeria);
    return (
      <div>
        <div className="mt-[65px]">
          <img src={data.imagen_portada} alt="cabecera" />{" "}
        </div>
        {/* Sección matricula */}
        <section className="mt-4 px-4 flex justify-center">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="w-full max-w-3xl bg-gradient-to-br from-[#004270] via-[#002f52] to-slate-950 rounded-2xl shadow-xl border border-[#febe10]/20 p-8 md:p-10 flex flex-col items-center text-center gap-6"
          >
            {/* Texto y Botones (Estilo 100% estático, sin condicionales) */}
            <div
              dangerouslySetInnerHTML={{ __html: data.texto_portada }}
              className="w-full flex flex-col items-center text-center  
                /* Párrafos */
                [&_p]:text-slate-200
                        
                [&_h4]:text-[#febe10]
                  [&_h4]:mt-6
                 [&_h4]:text-lg
                [&_h4_strong]:text-lg
                 [&_h4]:p-0

                /* Título Principal h2 */
               
                [&_h2]:text-white
               [&_h2]:p-0
                [&_h2_strong]:text-white

                   [&_h3]:text-white
                      [&_h3_strong]:text-white

                /* Botón de acción principal */
                [&_a]:inline-flex
                [&_a]:items-center
                [&_a]:justify-center
                [&_a]:px-7
                [&_a]:py-3.5
                [&_a]:mt-4
                [&_a]:text-sm
                [&_a]:font-bold
                [&_a]:text-slate-950
                [&_a]:bg-[#febe10]
                [&_a]:hover:bg-[#e0a60b]
                [&_a]:rounded-xl
                [&_a]:shadow-md
                [&_a]:transition-all
                [&_a]:duration-200
                [&_a]:hover:scale-105
                [&_a]:mx-auto
              "
            />

            {/* Modal / Galería: solo se monta si existen elementos */}
            {hasGallery && (
              <div className="pt-4 border-t border-white/10 w-full flex justify-center [&_button]:text-white   [&_button]:font-bold [&_button:hover]:text-[#febe10] ">
                <Modal
                  title="Proceso de matrícula"
                  content={
                    <div className="max-w-[350px] m-auto">
                      {" "}
                      <ImageGallery gallery={data.galeria} />
                    </div>
                  }
                />
              </div>
            )}
          </motion.div>
        </section>

        <div className="py-10">
          <OfferPosgrados></OfferPosgrados>
        </div>

        <div>
          <DescuentosPosgrados />
        </div>
      </div>
    );
  };
  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>

      <div className="padding2">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
          instagram="https://www.instagram.com/utplposgrados/"
          facebook="https://www.facebook.com/utplposgrados"
        ></ConectUs>
      </div>
    </>
  );
}

export default Posgrados;
